var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$userInfo)?_c('div',[_c('app-detail-header',{attrs:{"show-toggle":true,"show-delete":false,"show-save":false,"show-cancel":false,"show-new":false,"show-print":false},on:{"appDetailHeaderButtonClicked":_vm.onHeaderButtonClicked}}),_c('div',[_c('repx-list',{attrs:{"table-box-css-on":true}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }